import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * 제품 영양 성분 목록 조회
 * @param {Object} [params] 요청 데이터
 * @param {number[]} [params.factoryCodeSeqList] 선택한 공장
 * @param {string} [params.prdtYm] 월
 * @param {0 | 1} [params.searchType=1] 구분 (0: 제품 코드, 1: 배합비 코드)
 * @param {string} [params.searchCd] 코드
 * @return {Object} 응답 데이터
 */
async function requestList(params) {
  return api.get(API_URL.sfms.product.nutrition.list, { params });
}

/**
 * 제품 영양 성분 설계치 가져오기
 * @param {Object} params 요청 데이터
 * @param {number} data.factoryCodeSeq 공장
 * @param {string} data.prdtYm 월
 * @return {Object} 응답 데이터
 */
async function requestImport(params) {
  return api.get(API_URL.sfms.product.nutrition.import, { params });
}

export { requestList, requestImport };
